import { forwardRef, useMergeRefs } from '@chakra-ui/react-v2';
import { useState, useRef, useEffect } from 'react';

import {
  Input,
  NumberInput,
  NumberInputField,
} from '@frontend/legacy-components';

const InputContainer = forwardRef(
  (
    {
      initialValue,
      onCancel,
      onSave,
      type,
      autoFocus = false,
      numberFieldProps,
      ...passThroughProps
    },
    forwardedRef,
  ) => {
    const [internalValue, setInternalValue] = useState(null);
    const inputRef = useRef(null);
    const mergedRef = useMergeRefs(forwardedRef, inputRef);

    useEffect(() => {
      if (initialValue != internalValue) {
        setInternalValue(initialValue);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialValue]);

    const handleSave = () => {
      if (internalValue !== null && internalValue != initialValue) {
        onSave(internalValue);
        setInternalValue(null);
      } else if (onCancel) {
        onCancel();
      }
    };

    const onKeyPress = (e) => {
      if (e.key === 'Enter') {
        handleSave();
      }
    };

    // focus and select the input if autoFocus is true
    useEffect(() => {
      if (autoFocus) {
        setTimeout(() => {
          inputRef.current.focus();
          inputRef.current.select();
        });
      }
    }, [autoFocus]);

    if (type === 'number') {
      return (
        <NumberInput
          data-testid="input-container-numbers"
          onBlur={handleSave}
          onChange={(value) => {
            if (!value) {
              setInternalValue('');
            } else {
              const val = parseInt(value);
              setInternalValue(isNaN(val) ? '' : val);
            }
          }}
          ref={forwardedRef}
          onKeyPress={onKeyPress}
          value={internalValue ?? initialValue ?? ''}
          {...passThroughProps}
        >
          <NumberInputField ref={inputRef} {...numberFieldProps} />
        </NumberInput>
      );
    }

    return (
      <Input
        data-testid="input-container"
        onBlur={handleSave}
        onChange={(e) => setInternalValue(e.target.value)}
        onKeyPress={onKeyPress}
        value={internalValue ?? initialValue ?? ''}
        ref={mergedRef}
        {...passThroughProps}
      />
    );
  },
);

export default InputContainer;
